import styled from '@emotion/styled';
import { LazyImageSilk } from 'src/domains/sportsbook/webview/components/lazyImage/LazyImageSilk';
import { Trap } from 'src/domains/sportsbook/webview/components/trap/Trap';

export const WidgetTrapBox = styled('div', { label: 'WidgetTrapBox' })`
    align-items: center;
    display: flex;
    flex: 0 0 32px;
    height: 100%;
    margin: 0 12px;
    justify-content: center;
    svg {
        width: 26px;
    }
`;

export const TrapWrapper = styled(Trap, { label: 'TrapWrapper' })`
    height: 24px;
    width: 24px;
`;

export const WidgetSilkBox = styled('div', { label: 'WidgetSilkBox' })`
    align-items: center;
    display: flex;
    flex: 0 0 50px;
    height: 100%;
    justify-content: center;
    svg {
        width: 26px;
    }
`;

export const WidgetSilk = styled(LazyImageSilk, { label: 'WidgetSilk' })`
    width: 29px;
`;

export const OutrightFill = styled('div', { label: 'OutrightFill' })`
    margin-left: 12px;
`;
